import { TransferStatus } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export { TransferStatus };

export const transferStatusDictionary = createSimpleDictionary([
    { id: TransferStatus.Approved, name: 'dictionaries.transferStatus.approved' },
    { id: TransferStatus.Pending, name: 'dictionaries.transferStatus.pending' },
    { id: TransferStatus.Rejected, name: 'dictionaries.transferStatus.rejected' },
    { id: TransferStatus.Expired, name: 'dictionaries.transferStatus.expired' },
]);
